import PropTypes from 'prop-types'
import { cloneElement, useCallback, useEffect, useRef } from 'react'
import {
  EmptyData,
  RecursiveListItemContainer
} from '../../../styled-components'
import { typeFileQuickSelectOptions } from '../../../constants'
import { NotFound } from '../../../../../atoms/icons/core'
import { useIntl } from 'react-intl'
import NotFoundComponent from '../../../../../molecules/not-found'
import { useOnInView } from 'react-intersection-observer'

const QuickSelectRecursiveList = ({
  data = [],
  folderComponent,
  itemComponent,
  onScrollDown,
  ...props
}) => {
  const { formatMessage } = useIntl()
  const onScrollDownRef = useRef(onScrollDown)

  const isFolder = (type) => type === typeFileQuickSelectOptions.FOLDER

  useEffect(() => {
    onScrollDownRef.current = onScrollDown
  }, [onScrollDown])

  const bottomReachedRef = useOnInView(
    useCallback((inView) => {
      if (inView) {
        onScrollDownRef.current?.()
      }
    }, []),
    {
      rootMargin: '20px',
      skip: !onScrollDown
    }
  )

  if (data.length === 0) {
    return (
      <EmptyData>
        <NotFoundComponent
          icon={<NotFound style={{ width: '60px', height: '60px' }} />}
          header={formatMessage({ id: 'no_result_found' })}
          description={formatMessage({ id: 'no_result_found_description' })}
        />
      </EmptyData>
    )
  }

  return (
    <RecursiveListItemContainer {...props}>
      {data.map((item, index) => {
        if (isFolder(item.type)) {
          return cloneElement(folderComponent, {
            key: item?.id ?? index,
            item: item ?? null,
            folderComponent,
            itemComponent
          })
        }

        return cloneElement(itemComponent, {
          key: item?.id ?? index,
          item: item ?? null
        })
      })}
      <div
        ref={bottomReachedRef}
        style={{
          height: '1px'
        }}
      />
    </RecursiveListItemContainer>
  )
}

QuickSelectRecursiveList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      route: PropTypes.string,
      children: PropTypes.array
    })
  )
}

export default QuickSelectRecursiveList
